export default __webpack_public_path__ + "static/media/have-no-audience.6fbe5b25.png";